

theme.groups = {
    
    selectContainer: '',
    groups : [],

    // Boot
    init: function() {
    
        if (!theme.productGroup) {
            return false;
        }
        
        this.selectContainer = $('#productGroups')
        this.groups = this.selectContainer.data('groups');
        let options = this.selectContainer.find('option')
        let currentOption = this.selectContainer.find(':selected')
        let data = []
        data.groups = [];

        $.each(this.groups, function(index) {
            
            let group = this
            let items = []
            let swatch = []
            let isColour = false
            let current
			let active = false
			
            options.map(function(){
                
                let option = $(this)
                let slug = group.slugify()
				
				if(option.data('product-group-'+ slug)) {
					let opt = option.data('product-group-'+ slug);
					items.push(opt)
					active = true
				}

                current = currentOption.data('product-group-'+ slug)

                if (slug.includes('colour') || slug.includes('color')) {
                    isColour = true
                }

            })
        
            data.groups.push({
                'colour'    : isColour,
                'swatch'    : [],
                'current'   : current,
                'label'     : group,
                'slug'      : group.slugify(),
				'active'	: active,
                'items'     : items.filter(theme.groups._unique).sort(theme.helpers.sortAlphaNumeric),
				'disabled'	: []
            })

        })
        
		// Check for missing items
        $.each(data.groups, function(ig) {
          let _group = this
		  let slug = _group.slug.trim()
          let _items = _group.items;
          $.each(_items, function(ii) {
            let value = this.trim();
            let search = [];
            
            search.push('[data-product-group-'+slug+'="'+value+'"]');
            
            $.each(data.groups, function() {
              if(this.slug != slug) {
                search.push('[data-product-group-'+this.slug+'="'+this.current+'"]');
              }
            });
            let searchString = search.join('');
              
		    let variant = $(searchString);
			if(variant.length == 0) {
				data.groups[ig].disabled.push(value);
			}
		  })
		})
		
		// Remove missing items
		$.each(data.groups, function(ig) {
		  let _group = this;
		  let newItems = []
          $.each(_group.items, function(ii) {
			let _item = this;
            let active = true;
			$.each(_group.disabled, function(id) {
				let _disabled = this;
				if(_item == _disabled) {
					active = false;
				}
			})
			if (active) {
			  newItems.push(_item);
		    }
          })
		  
		  data.groups[ig].items = newItems;

        })
		
        let hasSwatchImages = (theme.productSwatches.length > 0) ? true : false        
		
        $.each(data.groups, function() {

            let that = this
            
            $.each(this.items, function() {

                let str = this.replace(/[^a-zA-Z ]/g, "")
                let slug = this.slugify() + '.png'
                let name = theme.helpers.search(str, theme.swatches.colours)
                let image = []

                if (hasSwatchImages) {
                    image = theme.helpers.search(slug, theme.productSwatches)
                    if (image.length > 0) {
                        if (! image[0].item.includes('v=')) {
                            image = false
                        } else {
                            name = []
                            name[0] = {
                                'item' : 'png'
                            }
                        }
                    }
                }

                that.swatch.push({
                    'slug'  : slug,
                    'name'  : (name.length > 0) ? name[0].item : false,
                    'image' : (image.length > 0) ? image[0].item : false
                })
                
            })

        })
		
        this.render(data)
        
        $('[data-product-variant]').on('click', this.goTo.bind(this))

    },
    
    /*
    * Render via Handlebars
    */
    render: function(data) {
		let template = $('#product-group-options').html();
        let instance = Handlebars.compile(template);
        let output = instance(data);
        $('#product-groups-container').html(output);
		$('#product-groups-loader').hide()
        $('#product-groups-container').fadeIn()
        SureifyProductOptions()
    },

    /*
    * Reload the variant
    */
    goTo: function(event) {
        
        event.preventDefault()
        
        let button = $(event.target);
        let slug = button.data('group-slug')

        // Remove active state of button clicked
        $('[data-group-slug="'+slug+'"]').attr('data-product-variant', '')

        // Set clicked button to active
        button.attr('data-product-variant', 'active')

        let activeVariants = $('[data-product-variant="active"]')

        let search = 'option'
        $.each(activeVariants, function() {
            let slug = $(this).data('group-slug').trim();
            let value = $(this).find('span').text().trim()
            search += '[data-product-group-'+slug+'="'+value+'"]'
        })

        // Find the URL to go to
        let variant = this.selectContainer.find(search.trim())

        // Go to the URL
        window.location = variant.data('product-url')

    },

    /*
    * Return a unique array
    */
    _unique: function(value, index, self) {
        return self.indexOf(value) === index;
    }

}

// Boot
$(function() {
    theme.groups.init();
});